(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeCardSummaryCtrl', PropriedadeCardSummary);

  PropriedadeCardSummary.$inject = [
    'StorageService',
    '$window',
    '$scope',
    '$routeParams',
    'AtividadesService',
    'LoadingService',
    'MessagesService',
    'PlantiosService',
    '$uibModal',
    '$route'
  ];
  // eslint-disable-next-line max-lines-per-function, max-params
  function PropriedadeCardSummary(StorageService, $window, $scope,
    $routeParams, AtividadesService, LoadingService,
    MessagesService, PlantiosService, $uibModal,
    $route) {
    const vm = this;
    let cards = null;

    //////////////////////////////////////////
    // Controller data
    vm.initialized = false;
    vm.timelineOperations = [
      { id: 'doenca', descricao: 'Doença' },
      { id: 'inseto', descricao: 'Inseto' },
      { id: 'invasora', descricao: 'Invasora' }
    ];

    //////////////////////////////////////////
    // Bindable methods
    vm.init = init;
    vm.activateTasks = activateTasks;
    vm.activateRecommendations = activateRecommendations;
    vm.activateStand = activateStand;
    vm.activateProductivity = activateProductivity;
    vm.iconClasses = iconClasses;
    vm.hasItemActive = hasItemActive;
    vm.openTimelineWindow = openTimelineWindow;
    vm.produtividadeUnidade = produtividadeUnidade;
    vm.editPlantio = editPlantio;
    vm.isCana = isCana;

    //////////////////////////////////////////
    // Function declarations

    function init(propriedadeCards) {
      cards = propriedadeCards;
      vm.initialized = true;
    }

    function iconClasses(item) {
      return cards ? cards.iconClasses(item) : null;
    }

    function hasItemActive(items) {
      return cards ? cards.hasItemActive(items) : false;
    }

    function isCana(cultura) {
      return AtividadesService.isCana(cultura);
    }

    /*
     * Interactions
     */
    function activateTasks(summary) {
      return cards.activate('tasks', {
        summary
      });
    }

    function activateRecommendations(summary) {
      return cards.activate('recommendations', {
        summary
      });
    }

    function activateStand(stand, summary) {
      cards.activate('standSummary', {
        stand,
        summary
      });

      if (!stand.active) {
        summary.active = false;
        resetMap();
      }
    }

    function activateProductivity(produtividade, summary) {
      cards.activate('produtividadeSummary', {
        productivity: produtividade,
        summary
      });

      if (!produtividade.active) {
        summary.active = false;
        resetMap();
      }
    }

    function openTimelineWindow(summary, cultivar, operation) {
      StorageService.set(KEY_TIMELINE_FILTERS, {
        gleba_id: summary.id,
        atividade_id: cultivar.cultura_id,
        operacao_id: (operation || {}).id,
        safra_id: cultivar.safra_id
      });

      $window.open('#!/timeline', '_blank');
    }

    function getGleba(name) {
      return $scope.$root.currentPropriedade.glebas.find((gleba) => gleba.descricao === name);
    }

    function resetMap() {
      $scope.$emit('setMarkers', []);
    }

    function produtividadeUnidade(atividade) {
      return AtividadesService.getProdutividadeUnidade(atividade);
    }

    function editPlantio(cultivar) {
      LoadingService.showLoading();
      return PlantiosService.getPlantioSimples({
        gleba: $scope.summary.id,
        atividade: cultivar.cultura_id,
        insumo: cultivar.id,
        safra: cultivar.safra_id,
        onlyActive: true
      })
        .then(({ data }) => {
          if (data.length > 1) {
            // eslint-disable-next-line
            throw 'multiple';
          } else if (data.length === 0) {
            // eslint-disable-next-line
            throw 'none';
          } else {
            modalEditPlantio(data[0]);
          }
        })
        .catch((error) => {
          if (error === 'multiple') {
            const msg = 'Não é possível editar este plantio pois há dois registros presentes com a mesma cultivar.';
            return MessagesService.alert(msg);
          }
          console.error(error);
          MessagesService.alert('Erro ao carregar plantio');
        })
        .finally(LoadingService.hideLoading);
    }

    function modalEditPlantio(plantio) {
      const modal = $uibModal.open({
        controller: 'EditPlantioModalCtrl',
        controllerAs: '$ctrl',
        resolve: { plantio },
        templateUrl: 'views/propriedade/edit-plantio-modal.html',
        windowClass: 'behind-loader'
      });
      return modal.result.then((result) => {
        if (result) {
          $route.reload();
        }
      });
    }

    //////////////////////////////////////////
    // Controller logic

    const watcher = $scope.$watch('card.initialized', () => {
      if (vm.initialized) {
        watcher(); // stop watching

        if ($routeParams.activeGleba && +$routeParams.activeGleba === (getGleba($scope.summary.descricao) || {}).id) {
          // eslint-disable-next-line
          if ($routeParams.produtividadeSummary !== undefined) {
            const produtividade = $scope.summary.gerais.produtividade[$routeParams.produtividadeSummary];
            return activateProductivity(produtividade, $scope.summary);
          }
          // eslint-disable-next-line
          if ($routeParams.standSummary !== undefined) {
            const stand = $scope.summary.gerais.stand[$routeParams.standSummary];
            return activateStand(stand, $scope.summary);
          }
        }
      }
    });
  }
}());
